import PropTypes from 'prop-types';
import React from 'react';

import uuid from '../../../../../core/utils/uuid';
import useStopPresentation from '../../../../../core/presentations/hooks/useStopPresentation';

import { sendClickPresentationNotificationAnalytic } from '../../../../../core/utils/analytics';
import {
  AlertTextWrapper,
  CustomSlideShowIcon,
  BoldText,
  Link,
} from './LiveSessionIndicator.styled';
import { Alert } from './SpaceBar.styled';
import useLivePresentation from '../../../../../core/presentations/hooks/useLivePresentation';

const LiveSessionIndicator = ({
  spaceId,
  isEducator,
  goToClassPresentation,
}) => {
  const { presentation, currentSession, isLoading } =
    useLivePresentation(spaceId);

  const open = !isLoading && currentSession !== undefined;

  const { id, title } = presentation || {};

  const { mutate: onEnd } = useStopPresentation(spaceId, id);

  if (open) {
    const onJoin = () => {
      let correlationId;

      if (!isEducator) {
        correlationId = uuid();
        sendClickPresentationNotificationAnalytic({
          spaceId,
          presentationId: presentation.id,
          presentationSessionId: currentSession.id,
          correlationId,
          joinedPresentationFrom: 'banner',
        });
      }

      goToClassPresentation(spaceId, id, correlationId);
    };

    return (
      <Alert>
        <AlertTextWrapper role="banner">
          <CustomSlideShowIcon />{' '}
          {isEducator ? (
            <>
              Class <BoldText>{title}</BoldText> is live
            </>
          ) : (
            <>
              A live class is happening <BoldText>{title}</BoldText>
            </>
          )}
        </AlertTextWrapper>
        {isEducator ? (
          <>
            <Link onClick={onEnd}>End presentation</Link>
            <Link onClick={onJoin}>Resume presentation</Link>
          </>
        ) : (
          <Link onClick={onJoin}>Join live class</Link>
        )}
      </Alert>
    );
  }

  return null;
};

LiveSessionIndicator.propTypes = {
  spaceId: PropTypes.string,
  isEducator: PropTypes.bool,
  goToClassPresentation: PropTypes.func.isRequired,
};

LiveSessionIndicator.defaultProps = {
  spaceId: null,
  isEducator: true,
};

export default LiveSessionIndicator;
